export const CARD_SIZE_OPTIONS = {
  standard: ["SMALL", "MEDIUM", "LARGE"],
  ads: ["SMALL", "MEDIUM", "LARGE"],
};

/** Visual layout uses exactly three widths; legacy XLARGE maps to LARGE. */
export const CARD_LAYOUT_SIZES = ["SMALL", "MEDIUM", "LARGE"];

export const normalizeCardLayoutSize = (size) => {
  const normalized = String(size || "MEDIUM").toUpperCase();
  if (normalized === "XLARGE") return "LARGE";
  if (CARD_LAYOUT_SIZES.includes(normalized)) return normalized;
  return "MEDIUM";
};

export const isFullWidthCardSize = (size) => normalizeCardLayoutSize(size) === "LARGE";

export const cardLayoutWidthSx = (size) =>
  isFullWidthCardSize(size)
    ? { width: "100%", flex: "0 0 100%" }
    : { width: "calc(50% - 4px)", flex: "0 0 calc(50% - 4px)" };

export const CARD_SIZE_STYLES = {
  SMALL: { padding: "10px 8px", minHeight: 44, fontSize: 10 },
  MEDIUM: { padding: "14px 10px", minHeight: 52, fontSize: 11 },
  LARGE: { padding: "18px 16px", minHeight: 64, fontSize: 13 },
};

/** Mirrors LeagueOrganizerSettingsService::PATCHABLE_BRANDING_KEYS */
export const PATCHABLE_BRANDING_KEYS = [
  "backGroundPrimaryColor",
  "backGroundSecondaryColor",
  "backGroundTertiaryColor",
  "textPrimaryColor",
  "textSecondaryColor",
  "textTertiaryColor",
  "textQuaternaryColor",
  "inputPrimaryColor",
  "inputSecondaryColor",
  "facebookUrl",
  "instagramUrl",
  "twitterUrl",
  "whatsapp",
  "email",
  "textNextMatchCard",
  "textBarCard",
  "textCardsCard",
  "textFairplayCard",
  "textFixtureCard",
  "textGoalersCard",
  "textOutstandingCard",
  "textPositionsCard",
  "textSuspendedCard",
  "textTeamCard",
  "enabledPositionsCard",
  "enabledGoalersCard",
  "enabledSuspendedCard",
  "enabledOutstandingCard",
  "enabledFairplayCard",
  "enabledCardsCard",
  "enabledTeamCard",
  "enabledBarCard",
  "enabledNextMatchCard",
  "enabledFixtureCard",
  "priorityFixtureCard",
  "priorityPositionsCard",
  "priorityGoalersCard",
  "prioritySuspendedCard",
  "priorityOutstandingCard",
  "priorityFairplayCard",
  "priorityCardsCard",
  "priorityBarCard",
  "priorityNextMatchCard",
  "priorityTeamCard",
  "ad1Enabled",
  "ad2Enabled",
  "ad3Enabled",
  "ad1Priority",
  "ad2Priority",
  "ad3Priority",
  "ad1Link",
  "ad2Link",
  "ad3Link",
  "ad1Available",
  "ad2Available",
  "ad3Available",
  "sizeFixtureCard",
  "sizePositionsCard",
  "sizeGoalersCard",
  "sizeSuspendedCard",
  "sizeOutstandingCard",
  "sizeFairplayCard",
  "sizeCardsCard",
  "sizeBarCard",
  "sizeTeamCard",
  "ad1Size",
  "ad2Size",
  "ad3Size",
  "loginLogoEnabled",
];

export const DEFAULT_BRANDING_FORM = {
  name: "",
  backGroundPrimaryColor: "#262626",
  backGroundSecondaryColor: "#262626",
  backGroundTertiaryColor: "#707070",
  textPrimaryColor: "#03F4CF",
  textSecondaryColor: "#B9B9B9",
  textTertiaryColor: "#03F4CF",
  textQuaternaryColor: "#EDEDED",
  inputPrimaryColor: "#03F4CF",
  inputSecondaryColor: "#262626",
  textNextMatchCard: "Próximos Partidos",
  textBarCard: "Bar",
  textCardsCard: "Tarjetas",
  textFairplayCard: "Fair Play",
  textFixtureCard: "Fixture",
  textGoalersCard: "Goleadores",
  textOutstandingCard: "Destacados",
  textPositionsCard: "Posiciones",
  textSuspendedCard: "Suspendidos",
  textTeamCard: "Planteles",
  enabledPositionsCard: true,
  enabledGoalersCard: true,
  enabledSuspendedCard: true,
  enabledOutstandingCard: true,
  enabledFairplayCard: true,
  enabledCardsCard: true,
  enabledTeamCard: true,
  enabledBarCard: true,
  enabledNextMatchCard: true,
  enabledFixtureCard: true,
  priorityFixtureCard: 0,
  priorityPositionsCard: 0,
  priorityGoalersCard: 0,
  prioritySuspendedCard: 0,
  priorityOutstandingCard: 0,
  priorityFairplayCard: 0,
  priorityCardsCard: 0,
  priorityBarCard: 0,
  priorityNextMatchCard: 0,
  priorityTeamCard: 0,
  sizeFixtureCard: "MEDIUM",
  sizePositionsCard: "MEDIUM",
  sizeGoalersCard: "MEDIUM",
  sizeSuspendedCard: "MEDIUM",
  sizeOutstandingCard: "MEDIUM",
  sizeFairplayCard: "MEDIUM",
  sizeCardsCard: "MEDIUM",
  sizeBarCard: "MEDIUM",
  sizeTeamCard: "MEDIUM",
  ad1Enabled: false,
  ad2Enabled: false,
  ad3Enabled: false,
  ad1Priority: 0,
  ad2Priority: 0,
  ad3Priority: 0,
  ad1Link: "",
  ad2Link: "",
  ad3Link: "",
  ad1Available: false,
  ad2Available: false,
  ad3Available: false,
  ad1Size: "MEDIUM",
  ad2Size: "MEDIUM",
  ad3Size: "MEDIUM",
  loginLogoEnabled: false,
  facebookUrl: "",
  instagramUrl: "",
  twitterUrl: "",
  whatsapp: "",
  email: "",
};

export const FULL_COLOR_FIELDS = [
  { key: "backGroundPrimaryColor", labelId: "gestion.branding.colors.bgPrimary" },
  { key: "backGroundSecondaryColor", labelId: "gestion.branding.colors.bgSecondary" },
  { key: "backGroundTertiaryColor", labelId: "gestion.branding.colors.bgTertiary" },
  { key: "textPrimaryColor", labelId: "gestion.branding.colors.textPrimary" },
  { key: "textSecondaryColor", labelId: "gestion.branding.colors.textSecondary" },
  { key: "textTertiaryColor", labelId: "gestion.branding.colors.textTertiary" },
  { key: "textQuaternaryColor", labelId: "gestion.branding.colors.textQuaternary" },
  { key: "inputPrimaryColor", labelId: "gestion.branding.colors.inputPrimary" },
  { key: "inputSecondaryColor", labelId: "gestion.branding.colors.inputSecondary" },
];
